export enum EditState {
  added = 0,
  deleted = 1,
  detached = 2,
  modified = 3,
  unchanged = 4
}
